


// src/components/helpers/fetchMapLayersStockMap.js
import Parse from '../../parseConfig';

/**
 * Fetch the always-on Parcel Boundaries layer.
 * Hard-coded to objectId = vss8qcg5ob.
 */
export const fetchParcelBoundariesLayer = async () => {
  try {
    const MapLayer = Parse.Object.extend('MapLayer');
    const query = new Parse.Query(MapLayer);
    query.equalTo('objectId', 'vss8qcg5ob');

    const result = await query.first();
    if (!result) {
      throw new Error('Parcel Boundaries layer not found');
    }

    return result.get('format'); // the URL template
  } catch (error) {
    console.error('[fetchParcelBoundariesLayer] Error:', error);
    return null;
  }
};

/**
 * Fetch arbitrary map layers by objectId (e.g., associatedMapLayer from HouseLand).
 * Accepts an array of IDs and returns { id: url }.
 */
export const fetchAssociatedLayers = async (objectIds = []) => {
  if (!objectIds.length) return {};

  try {
    const MapLayer = Parse.Object.extend('MapLayer');
    const query = new Parse.Query(MapLayer);
    query.containedIn('objectId', objectIds);

    const results = await query.find();

    const urls = {};
    results.forEach((layer) => {
      urls[layer.id] = layer.get('format');
    });

    return urls;
  } catch (error) {
    console.error('[fetchAssociatedLayers] Error:', error);
    return {};
  }
};


